import { ParsedCalendarDetails } from "components/Meetings/models";
import { produce } from "immer";
import { Store } from "reducers/rootReducer";

/* Constants */
const SET_CALENDARS = "app/register/SET_CALENDARS";

type ValueOf<T> = T[keyof T];

type RegisterState = {
  calendars: ParsedCalendarDetails[];
};

type RegisterAction = {
  type: typeof SET_CALENDARS;
  payload: ParsedCalendarDetails[];
};

/* Reducer */

const initialRegisterState: RegisterState = {
  calendars: [],
};

export const calendarSyncReducer = (
  state: RegisterState = initialRegisterState,
  action: RegisterAction
): RegisterState =>
  produce(state, draft => {
    switch (action.type) {
      case SET_CALENDARS:
        draft.calendars = action.payload;
        break;
    }
  });

/* Action Creators */

export const setCalendars = (
  payload: ParsedCalendarDetails[]
): RegisterAction => ({
  type: SET_CALENDARS,
  payload,
});

/* Selectors */
export const selectCalendars = (state: Store) => state.calendarSync.calendars;
